import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';

import Loading from "../../loading";
import TableFormat from "../../../partials/TableFormat";
import Snackbar from "../../snackbar";
import { styles } from "./styles";
// import EditCard from "./edit";
const headCells = [
  {
    key: "deviceId",
    numeric: false,
    disablePadding: false,
    label: "sms_manage_device_title_deviceid",
  },
  {
    key: "versionOS",
    numeric: false,
    disablePadding: false,
    label: "sms_manage_device_title_version",
  },
  {
    key: "model",
    numeric: false,
    disablePadding: false,
    label: "sms_manage_device_title_model",
  },
];

class SMSManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: [],
    };
  }
  componentDidMount() {
    this.getListDevives();
  }
  getListDevives = async (payload) => {
    this.loading.startLoading();
    await this.props.getList(payload);
    this.loading.stopLoading();
  };
  render() {
    const { t, listDevices, total, count, classes } = this.props;
    const { collapse = [] } = this.state;
    return (
      <React.Fragment>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <TableFormat
            onRef={(ref) => (this.mTable = ref)}
            title={t("sms_tag_device_manage")}
            totalCount={total}
            count={count}
            showFilter={false}
            headCells={headCells}
            size={"medium"}
            collapse={collapse}
            isCollapse={false}
            hiddenSearch={true}
            showCheckBox={false}
            showFilterBranch={false}
            getList={this.getListDevives}
            rows={listDevices.map((row, index) => {
                return {
                  id: row.code,
                  deviceId:
                    <div className={classes.wrapDevice}>
                      <PhoneAndroidIcon color="primary" className={classes.icon} />{row.deviceId}
                    </div>,
                  versionOS: row.versionOS,
                  model: row.model,
                };
            })}
        />
      </React.Fragment>
    );
  }
}

SMSManage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  listDevices: state.developerAccount.listDevices,
  totalDevices: state.developerAccount.totalDevices,
  countDevices: state.developerAccount.countDevices,
});
const mapDispatch = (dispatch) => ({
  getList: dispatch.developerAccount.getListDevives,
});
export default translate("translations")(
  withStyles(styles, { withTheme: true })(
    connect(mapState, mapDispatch)(SMSManage)
  )
);